<section class="container">
<h3 class="text-center">
  {{ data.title.split(" ")[0] }}
  <span> {{ data.title.split(" ").slice(1).join(" ") }}</span>
</h3>
<div class="container">
  <div class="row">
    <div
      class="col-12 col-sm-6 col-md-4 mt-2"
      *ngFor="let item of data.services"
    >
      <div class="product-card" *ngIf="data.details.isDetails" [routerLink]="getDetailsUrl(item)">
        <div class="image-container">
          <img
            [src]="item.imageIconPath"
            alt="XBoard V7 Series Interface"
            class="screen-content"
          />
        </div>

        <div class="card-content">
          <h4 class="card-title">{{ item.titleTr }}</h4>
          <p>{{ item.summary }}</p>

          <button class="learn-more">
            {{ "Learn More" | translate }}
            <span class="arrow">→</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</section>